import { IconButton } from '@mui/material';
import { useFontSize } from '@src/contexts/FontSizeContext';

export function HomeFontSizeButton() {
  const { openDialog, showInHome } = useFontSize();

  function handleClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    // Explicitly call openDialog with the fromHome parameter
    if (openDialog) {
      openDialog(true);
    }
  }

  if (!showInHome) {
    return null;
  }

  return (
    <IconButton
      onClick={handleClick}
      sx={{
        position: 'fixed',
        top: 24,
        // right: 24,
        zIndex: 9999,
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        '&:hover': {
          backgroundColor: 'primary.dark',
          transform: 'scale(1.1)',
        },
        width: 60,
        height: 60,
        boxShadow: 3,
        fontSize: '2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease',
      }}
      aria-label="调整字体大小"
      title="调整字体大小"
    >
      🔍
    </IconButton>
  );
}
